import clsx from 'clsx';
import { useCallback, useState } from 'react';

import { SettingsIcon } from 'icons';
import { IconButton, Menu, PopoverOrigin, styled } from 'netline-ui';
import { NavigationArea } from 'types';

import { usePreferencesMenuItems } from '../../Navigation';

import styles, {
  preferencesMenuIconButtonClasses,
  preferencesMenuIconButtonRootClasses,
} from './PreferencesMenu.styles';

const PreferencesMenuIconButtonRoot = styled(IconButton, { name: preferencesMenuIconButtonClasses.$name })(styles);

const anchorOrigin: PopoverOrigin = {
  vertical: 'bottom',
  horizontal: 'right',
};

const transformOrigin: PopoverOrigin = {
  vertical: 'top',
  horizontal: 'right',
};

const PreferencesMenu = () => {
  const [anchorEl, setAnchorEl] = useState(null);
  const handleToggleMenuClick = useCallback((event) => setAnchorEl(event.currentTarget), []);
  const closeMenu = useCallback(() => setAnchorEl(null), []);

  const wrappedItems = usePreferencesMenuItems(NavigationArea.Sidebar, closeMenu, closeMenu);

  return (
    <>
      <PreferencesMenuIconButtonRoot
        size="large"
        className={clsx(preferencesMenuIconButtonClasses.root, {
          [preferencesMenuIconButtonRootClasses.hideIcon]: !wrappedItems.length,
        })}
        onClick={handleToggleMenuClick}
        data-testid="PreferencesMenuIconButton-root"
      >
        <SettingsIcon />
      </PreferencesMenuIconButtonRoot>
      <Menu
        keepMounted
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={closeMenu}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        {wrappedItems}
      </Menu>
    </>
  );
};
export default PreferencesMenu;
